import React from "react";
import Icon from "../../common/Icon/Icon";
import Typography from "../../common/Typography/Typography";

export interface FileItemEntity {
    icon: "arrow_left" | "file_image" | "file_blank_fill" | "file_pdf" | "file_archive" | "folder" | "download" | "info_outline";
    name: string;
    onClick?: () => void;
}

const FileItem = ({ icon, name, onClick }: FileItemEntity) => (
    <button type="button" className="flex border-2 border-pine-800 p-1 gap-0.5 items-center rounded text-left h-full" onClick={onClick}>
        <Icon icon={icon} className="flex-shrink-0 bg-white" />
        <Typography variant="meta" fontSize="090" className="break-all">
            {name}
        </Typography>
    </button>
);

export default FileItem;
